import { Divider } from '@material-ui/core';
import { User } from 'lib/generated/graphql';
import InvitedUser from '../InvitedUser';

interface InviteProps {
  referralType: 'FOUNDER' | 'BUILDER';
  user: User;
}

const SuccessfulInvites = ({ referralType, user }: InviteProps) => {
  const founderInvited = user?.invited?.filter(invited => invited.role === 'CUSTOMER');
  const builderInvited = user?.invited?.filter(invited => invited.role === 'BUILDER');

  return (
    <div>
      {founderInvited?.length > 0 && referralType === 'FOUNDER' && (
        <div className="px-8 py-8 mt-8 bg-white rounded-2xl shadow max-w-[915px] mb-4">
          <div className="lg:grid grid-cols-7 ">
            <div className="col-start-1 col-end-4">
              <h2 className="text-2xl sm:text-2xl font-medium mb-5">Successful Founder Invites</h2>
              <div className="items-center gap-x-6"></div>
            </div>
            {founderInvited?.length < 5 && (
              <div className="lg: col-start-5 col-end-8 max-w-sm">
                <div className="text-md rounded-xl indent-5 px-0 py-2 items-center bg-huddlePink text-[#C1259F] mb-4">
                  Invite 5 Founders to Earn a 🔭 Scout Badge
                </div>
              </div>
            )}
          </div>
          <Divider color="#C8C8C8" className="visible sm:invisible md:invisible" />
          <div className="mb-5 grid grid-cols-5 invisible sm:visible">
            <div className="lg: col-start-1 col-end-2 text-gray-500">Name</div>
            <div className="lg: col-start-4 col-end-5 text-gray-500 lg:visible md:invisible sm:invisible">Status</div>
          </div>
          <div className="flex flex-col gap-y-5">
            {referralType === 'FOUNDER' &&
              founderInvited?.map(invited => (
                <InvitedUser key={invited.id} user={invited} referralType={referralType} />
              ))}
          </div>
        </div>
      )}

      {builderInvited?.length > 0 && referralType === 'BUILDER' && (
        <div className="px-8 py-8 mt-8 bg-white rounded-2xl shadow max-w-[915px] mb-4">
          <h2 className="text-2xl sm:text-2xl font-medium mb-5">Successful Builder Invites</h2>
          <Divider color="#C8C8C8" className="visible sm:invisible md:invisible" />
          <div className="items-center gap-x-6">
            <div className="mb-5 grid grid-cols-5 invisible sm:visible">
              <div className="col-start-1 col-end-2 text-gray-500">Name</div>
              <div className="lg: col-start-4 col-end-5 text-gray-500 lg:visible md:invisible sm:invisible">Status</div>
            </div>
            <div className="flex flex-col gap-y-5">
              {referralType === 'BUILDER' &&
                builderInvited?.map(invited => (
                  <InvitedUser key={invited.id} user={invited} referralType={referralType} />
                ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SuccessfulInvites;
